export enum OriginalType {
    FROM_ME = "FROM_ME",
    TO_ME = "TO_ME"
}
